import Vue from 'vue';
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

export default Vue.observable({
  loggedIn: Vue.$cookies.get("user") != null,
  unreadMessageCount: 0,
  newNews: false,
  newJournals: false,
  newLinks: false,
  newNurseries: false,
  newTopicPosts: false,
  pagingKey: "paging-",
  setCurrentUser(token) {
    if (token == null) {
      Vue.$cookies.remove("user");
      this.loggedIn = false;
      this.unreadMessageCount = 0;
      this.newNews = false;
      this.newJournals = false;
      this.newLinks = false;
      this.newNurseries = false;
      this.newTopicPosts = false;
    } else {
      Vue.$cookies.set("user", token, "1m");
      this.loggedIn = true;
    }
  },
  getCurrentUser() {
    return Vue.$cookies.get("user");
  },
  getDeviceId() {
    var deviceId = Vue.$cookies.get("deviceid");
		if (!deviceId) {
			deviceId = crypto.randomUUID();
			Vue.$cookies.set("deviceid", deviceId, "12m");
		}
		return deviceId
  },
  setUnreadMessageCount(count) {
    this.unreadMessageCount = count;
  },
  getUnreadMessageCount() {
    return this.unreadMessageCount;
  },
  setNewNews(flag) {
    this.newNews = flag;
  },
  getNewNews() {
    return this.newNews;
  },
  setNewJournals(flag) {
    this.newJournals = flag;
  },
  getNewJournals() {
    return this.newJournals;
  },
  setNewLinks(flag) {
    this.newLinks = flag;
  },
  getNewLinks() {
    return this.newLinks;
  },
  setNewTopicPosts(flag) {
    this.newTopicPosts = flag;
  },
  getNewTopicPosts() {
    return this.newTopicPosts;
  },
  setNewNurseries(flag) {
    this.newNurseries = flag;
  },
  getNewNurseries() {
    return this.newNurseries;
  },
  setPagingValue(key, value) {
    if (key) {
      return Vue.$cookies.set(this.pagingKey + key, value, "1m");
    }
  },
  getPagingValue(key) {
    let page = Vue.$cookies.get(this.pagingKey + key)
      ? Vue.$cookies.get(this.pagingKey + key)
      : 1;
    return page;
  },
  clearPagingValues() {
    for (let key in Vue.$cookies.keys()) {
      if (
        key &&
        Vue.$cookies.keys()[key] &&
        Vue.$cookies.keys()[key].startsWith(this.pagingKey)
      ) {
        Vue.$cookies.remove(Vue.$cookies.keys()[key]);
      }
    }
  },
});